<div class="order-details">
  <div class="order-details__header">
    @if (order && !isArchived) {
      <span
        matTooltip="{{ isBeingWatched ? 'Remove from watch list' : 'Add to watch list' }}"
        class="material-symbols-outlined order-details__header--watch"
        [ngClass]="{ 'order-details__header--unwatched': !isBeingWatched }"
        (click)="toggleWatch()"
        >star</span
      >
    }
    <div style="width: 100%">{{ order?.orderNo }}</div>
    <a (click)="detailsClosed.emit()" class="material-symbols-outlined order-details__header--close">close</a>
  </div>
  <mat-tab-group class="order-details__tab-group">
    <mat-tab>
      <ng-template mat-tab-label><span class="material-symbols-outlined">info</span>DETAILS</ng-template>
      <app-details [order]="order" [isArchived]="isArchived"></app-details>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label><span class="material-symbols-outlined">widgets</span>ITEMS</ng-template>
      <app-items [order]="order"></app-items>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label><span class="material-symbols-outlined">assignment_late</span>EXCEPTIONS</ng-template>
      <app-order-exception-table [orderExceptions]="order?.exceptions || null"></app-order-exception-table>
    </mat-tab>
  </mat-tab-group>
</div>
